import "src/css/widgets/widgets.css";
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import DialerPhoneStatus from "./dialerphonestatus";
import DialersFormStatus from "./dialersformstatus";



function DialerCard(props) {

    return (
        <Col lg={2}>
            <div className={"d-flex align-items-center bg-light-primary"} style={{ width: "100%", padding: "5px", borderRadius: "10px" }} >
                <div className="w-100">
                    <div className="fs-7 text-muted fw-bold">
                        <Row>
                            <Col>
                                <div className="fs-7 text-dark fw-bold w-100">  {props.dialer.extension}</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={2}>
                                <DialerPhoneStatus dialer={props.dialer} ></DialerPhoneStatus>
                            </Col>
                            <Col>
                                {props.dialer.interlocutor}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={2}>
                                <DialersFormStatus dialer={props.dialer} ></DialersFormStatus>
                            </Col>
                            <Col>
                                {props.dialer.campaign}
                            </Col>
                        </Row>

                    </div>
                </div>

            </div>
        </Col>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token
    };
};

export default connect(mapStateToProps, {})(DialerCard);